module.exports = __webpack_public_path__ + "media/images/landing/avatar1-44aec0ffb9eca5984ca04e89017a6843.jpg";